// Chord chart → plain text for chats and notes (and the bar density rule the print sheet shares). No DOM.

import type { ChartMeasure } from "../../types/domain";
import { measureSegments } from "../grid/segments";

export interface ChartTextInput {
  title: string;
  meta: string;                        // key · tempo · capo line, already localized
  measures: ChartMeasure[];
  /** chord spelling for the current key/capo (ChordView.name); `measure`/`segment` place it, for play styles */
  name: (label: string, measure: number, segment: number) => string;
  url?: string;
}

/** 4 bars per line, chords only — beat dots read as noise outside a printed grid */
export function chartText({ title, meta, measures, name, url }: ChartTextInput): string {
  const lines = [title, meta, ""];
  for (let i = 0; i < measures.length; i += 4) {
    const bars = measures.slice(i, i + 4).map((m, k) => measureSegments(m).map((s, j) => (s.chord ? name(s.chord, i + k, j) : "-")).join(" "));
    lines.push(`| ${bars.join(" | ")} |`);
  }
  if (url) lines.push("", url);
  return lines.join("\n");
}

/** a printed bar switches to compact, wrapping type when it holds many chords or long names */
export function isDenseBar(names: string[]): boolean {
  return names.length >= 3 || names.join("").length > 9;
}
